"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TinVerificationStatus = exports.WingspanToTrackClassification = void 0;
var WingspanToTrackClassification;
(function (WingspanToTrackClassification) {
    WingspanToTrackClassification["None"] = "soleProprietor";
    WingspanToTrackClassification["SoleProprietorship"] = "soleProprietor";
    WingspanToTrackClassification["LlcSingleMember"] = "singleMemberLlc";
    WingspanToTrackClassification["LlcMultiMember"] = "llcPartnership";
    WingspanToTrackClassification["CorporationS"] = "sCorporation";
    WingspanToTrackClassification["LLCCorporationS"] = "llcSCorporation";
    WingspanToTrackClassification["LLCCorporationC"] = "llcCCorporation";
    WingspanToTrackClassification["LLCPartnership"] = "llcPartnership";
    WingspanToTrackClassification["CorporationC"] = "cCorporation";
    WingspanToTrackClassification["Partnership"] = "partnership";
})(WingspanToTrackClassification = exports.WingspanToTrackClassification || (exports.WingspanToTrackClassification = {}));
var TinVerificationStatus;
(function (TinVerificationStatus) {
    TinVerificationStatus["error"] = "error";
    TinVerificationStatus["lockedOut"] = "lockedOut";
    TinVerificationStatus["mismatch"] = "mismatch";
    TinVerificationStatus["pending"] = "pending";
    TinVerificationStatus["unverified"] = "unverified";
    TinVerificationStatus["verified"] = "verified";
})(TinVerificationStatus = exports.TinVerificationStatus || (exports.TinVerificationStatus = {}));
//# sourceMappingURL=trackUser.js.map